






//reset button 

$(document).ready(function() {
    var resetButton = $('.resetButtonwrap a');

    function toggleResetButton() {
        var hasFilters = $('.am-shopby-filter-make').val() ||
                         $('.am-shopby-filter-model').val() ||
                         $('.am-shopby-filter-year').val() ||
                         $('input[type="checkbox"]:checked').length > 0;

        if (hasFilters) {
            resetButton.show();
        } else {
            resetButton.hide();
        }
    }

    // Hide reset button initially
    resetButton.hide();

    // Monitor changes in filters
    $('.am-shopby-filter-make, .am-shopby-filter-model, .am-shopby-filter-year, input[type="checkbox"]').on('change', function() {
        toggleResetButton();
    });

    // Handle reset button click
    resetButton.on('click', function(e) {
        e.preventDefault();
        $('input[type="checkbox"]').prop('checked', false);
        $('.am-shopby-filter-make, .am-shopby-filter-model, .am-shopby-filter-year').val('').prop('disabled', true);
        toggleResetButton(); // Hide button after reset
    });
});
$(document).ready(function () {
    function updateFilterCount() {
        var filterCount = 0;

        // Count selected dropdowns
        $('.am-shopby-filter-make, .am-shopby-filter-model, .am-shopby-filter-year').each(function () {
            if ($(this).val()) {
                filterCount++;
            }
        });

        // Count checked checkboxes
        filterCount += $('input[type="checkbox"]:checked').length;

        // Update the filter count display
        if (filterCount > 0) {
            $('.filter-count').text(`${filterCount}`).show();
        } else {
            $('.filter-count').hide();
        }
    }

    // Event listeners for dropdowns and checkboxes
    $('.am-shopby-filter-make, .am-shopby-filter-model, .am-shopby-filter-year, input[type="checkbox"]').on('change', function () {
        updateFilterCount();
    });

    // On page load, update count based on pre-selected filters
    updateFilterCount();
});
